import { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import {
  setHumanImage,
  setClotheImage,
  clearTryItOn,
  clearResult,
} from "@/app/lib/features/tryItOn/tryItOn.slice";
import { processTryItOn } from "@/app/lib/features/tryItOn/tryItOn.thunk";

/**
 * useTryItOn tüm `state.tryItOn` slice'ına abone olur. Ürün kartı yalnızca
 * "denenecek görseli seç" işlemini yapıyor — okuma yok. Bu dispatch-only sürüm
 * aboneliği tamamen kaldırır: try-on akışı ilerlerken kartlar render olmaz.
 */
export const useSelectClotheImage = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (imageUrl: string) => {
      dispatch(setClotheImage(imageUrl));
    },
    [dispatch],
  );
};

const useTryItOn = () => {
  const dispatch = useAppDispatch();
  const { humanImage, clotheImage, resultImage, isLoading, error } =
    useAppSelector((state) => state.tryItOn);

  const humanImageUrl = useMemo(() => {
    if (!humanImage) return null;
    return URL.createObjectURL(humanImage);
  }, [humanImage]);

  // Ürün fotoğrafını kaydet (Dene butonuna tıklandığında)
  const selectClotheImage = useCallback(
    (imageUrl: string) => {
      dispatch(setClotheImage(imageUrl));
    },
    [dispatch]
  );

  // Kullanıcı fotoğrafını yükle ve API'ye istek at
  const uploadAndProcess = useCallback(
    (humanFile: File) => {
      if (!clotheImage) {
        console.error("Ürün fotoğrafı seçilmedi");
        return;
      }
      dispatch(setHumanImage(humanFile));
      dispatch(processTryItOn({ humanImage: humanFile, clotheImage }));
    },
    [dispatch, clotheImage]
  );

  const reset = useCallback(() => {
    dispatch(clearTryItOn());
  }, [dispatch]);

  const resetResult = useCallback(() => {
    dispatch(clearResult());
  }, [dispatch]);

  return {
    humanImage,
    humanImageUrl,
    clotheImage,
    resultImage,
    isLoading,
    error,
    selectClotheImage,
    uploadAndProcess,
    reset,
    resetResult,
  };
};

export default useTryItOn;
